// extracted by mini-css-extract-plugin
module.exports = {"c9x2k8a":"c9x2k8a","dcnvdym":"dcnvdym"};